import { motion, AnimatePresence } from 'framer-motion'

export default function TutorialModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/85 p-4">
          <motion.div
            initial={{ scale: 0.96, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.18 }}
            className="w-full max-w-2xl bg-[#0A0A0A] border border-white/10"
            role="dialog"
            aria-modal="true"
          >
            <div className="p-4">
              <div className="border border-white/10 bg-black overflow-hidden">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-full max-h-[60vh] object-contain"
                  style={{ display: 'block' }}
                >
                  <source src="/video/dragtutorial.webm" type="video/webm" />
                </video>
              </div>

              <div className="mt-3 text-sm text-white/70 font-serif">
                Kartı hareket ettirmek için üstüne basılı tutup sürükle.
              </div>

              <div className="mt-4 flex justify-end">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 bg-white text-black font-serif font-bold"
                >
                  Tamam
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}
